/** @jsx jsx */
import React, { Fragment } from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import _ from 'lodash'
import PopupUtils from '@utils/popup-utils'
import { toUserActivityTypeDesc } from '@utils/utils'
import { isMobile } from 'react-device-detect'

// css
import { ActivityScoreNoticeWrap, ActivityScorePopup } from './index.style'
import { Button } from '@styles/button.style'
import activityScoreCharacterImg from '@assets/images/bg/character/activity-score-notice-character.png'
import activityScoreCharacterHandsImg from '@assets/images/bg/character/activity-score-notice-character-hands.png'
import classNames from 'classnames'
import useRootStore from '@store/useRootStore'
import { USER_ACTIVITY_TYPE } from '@v2/constants/activity'
import { GlobalStoreKey } from '@v2/constants/common'
import { UserActivityScoreOption } from '@interface/admin/common'
import { GmoneyIco } from '@shared/Icon/MoneyIcon'

export const ActivityScoreNoticePopup: React.FC = observer((): React.ReactElement => {
  const { globalStore, chattingStore } = useRootStore()
  const { activityScoreNoticeQueue } = globalStore
  if (_.isEmpty(activityScoreNoticeQueue)) {
    return <Fragment/>
  }

  // 활동점수 획득 횟수 테스트를 위해 임의로 작성한 코드입니다.
  const AcquiredActivityScore: Record<string, number> = {}

  /*
  [테스트내용] 채팅(MO)의 <ActivityScoreNoticePopup/> 스타일 수정을 위해 작성한 코드입니다.
  [이슈링크] (https://task.zempublic.co.kr/view.php?id=9591)
  */
  let activityTypeEle

  for (const userActivityInfo of activityScoreNoticeQueue) {
    const { activityType } = userActivityInfo
    AcquiredActivityScore[activityType] = (AcquiredActivityScore[activityType] || 0) + 1

    activityTypeEle = activityType
  }
  const AcquiredActivityScoreCount = Object.keys(AcquiredActivityScore).length

  const isMobileChatting = ((activityTypeEle === USER_ACTIVITY_TYPE.BET_HISTORY_SHARED_TO_CHAT)
    || (activityTypeEle === USER_ACTIVITY_TYPE.CHEER_FOR_TEAM)) && isMobile && chattingStore.isVisibleChattingModal

  const elemList = activityScoreNoticeQueue.map((userActivityInfo, itemIndex): JSX.Element => {
    const {
      monthlyActivityScore, activityType,
      activityRewardAvailable, todayScoredActivityCount,
      thisActivityScore
    } = userActivityInfo

    const optionValue = globalStore.findGlobalSetting(GlobalStoreKey.USER_ACTIVITY_SCORE_OPTIONS).value
    const scoreOptions = JSON.parse(optionValue) as UserActivityScoreOption[]
    const dailyLimitScore = _.find(scoreOptions, { activityType })?.dailyLimit ?? 0

    const showRewardPopup = (): void => {
      PopupUtils.showUserActivityScore()
    }

    setTimeout((): void => {
      globalStore.removeActivityScoreNoticeQueue(userActivityInfo.activityId)
    }, activityRewardAvailable ? 7100 : 5100)

    const ActivityScoreNoticePopupClassName = classNames('activity-score-notice-popup', {
      'chatting': isMobileChatting,
      'achieved': activityRewardAvailable,
    })

    return (
      <ActivityScoreNoticeWrap key={`activity-score-notice-popup_${userActivityInfo.activityId}`} onClick={showRewardPopup} className={ActivityScoreNoticePopupClassName}>
        {itemIndex === 0 && activityRewardAvailable && (
          <Fragment>
            <img src={activityScoreCharacterHandsImg} className="activity-score-character-hands" alt="활동점수 획득 캐릭터"/>
            <img src={activityScoreCharacterImg} className="activity-score-character" alt="활동점수 획득 캐릭터"/>
          </Fragment>
        )}
        <p className="activity-score">+{thisActivityScore}점</p>
        {!isMobileChatting ?
          (<Fragment>
            <div className="contents distance">
            <p className="title">
              {toUserActivityTypeDesc(activityType)}
              <span className="daily-limit">({todayScoredActivityCount}/{dailyLimitScore})</span>
            </p>
            <span className="user-activity-score">
              활동점수 <span className="total-activity-score">{monthlyActivityScore}</span>점 달성!
              </span>
            </div>
            {activityRewardAvailable &&
              <Button TP className="show-activity-score-button"><GmoneyIco/> 보상받기</Button>
            }
          </Fragment>)
          :
          (<div className="contents-wrap">
            <div className={(activityType === USER_ACTIVITY_TYPE.BET_HISTORY_SHARED_TO_CHAT || USER_ACTIVITY_TYPE.USER_PICK_WRITTEN) ? 'contents distance' : 'contents'}>
              <p className="title">
                {toUserActivityTypeDesc(activityType)}
                <span className="daily-limit">({todayScoredActivityCount}/{dailyLimitScore})</span>
              </p>
              <span className="user-activity-score">
                활동점수 <span className="total-activity-score">{monthlyActivityScore}</span>점 달성!</span>
            </div>
            {activityRewardAvailable &&
              <Button TP className="show-activity-score-button"><GmoneyIco/> 보상받기</Button>
            }
          </div>)
        }
      </ActivityScoreNoticeWrap>
    )
  })

  const ActivityScorePopupClass = classNames('active', {
    // 'achieved': activityRewardAvailable,
    'chatting': isMobileChatting,
    /** 연속적인 활동점수 획득 시 스타일을 위해 임의로 작성한 조건입니다.
     * 예시상황 1. 실시간 채팅창 내 <베팅내역 공유>와 <응원글 작성>를 통해 동시에 점수 획득하는 경우
     */
    'continuous-acq': AcquiredActivityScoreCount >= 2,
  })

  return <ActivityScorePopup className={ActivityScorePopupClass}>{elemList}</ActivityScorePopup>
})
